<template>
	<div>
		<div class="d-flex justify-space-between">
			<div class="text-h5">Data Produk</div>
		</div>
		<v-card class="mt-3 mb-3" outlined>
			<v-list color="deep-purple lighten-5" dark class="pa-3">
				<v-list-item dense class="px-1">
					<v-spacer></v-spacer>
					<v-btn text depressed class="primary mr-2" @click="exportData">
						<v-icon>mdi-export</v-icon>
						<div class="pl-2 text-capitalize">Export</div>
					</v-btn>
					<v-btn depressed class="primary" @click="dropfilter = !dropfilter">
						<v-icon>mdi-filter</v-icon>
						<div class="pl-2">Filter</div>
					</v-btn>
				</v-list-item>
			</v-list>
		</v-card>
		<v-slide-y-transition>
			<v-card outlined class="mb-3" v-if="dropfilter">
				<filterComponent v-if="dropfilter" @searchFilter="searchFilter" @onResetFilter="onResetFilter"></filterComponent>
			</v-card>
		</v-slide-y-transition>
		<v-card outlined >
			<v-data-table loading disable-pagination :headers="headers" :items="listProduct" :search="search" hide-default-footer :options.sync="option" :server-items-length="paginationProduct.total_data" class="table-w-120">
				<template v-slot:item.product_is_active="{ item }">
					{{ item.product_is_active == 1 ? 'Aktif' : 'Tidak Aktif' }}
				</template>
				<template v-slot:progress>
					<div>
					</div>
				</template>
				<template v-slot:loading>
					<div class="py-3" v-if="!paginationProduct">
						<loading-data></loading-data>
					</div>
					<div class="py-3" v-else>
						<not-found></not-found>
					</div>
				</template>
			</v-data-table>
		</v-card>
		<div class="pt-5" v-if="paginationProduct">
			<v-row>
				<v-col cols="11" md="11" class="py-0 d-flex justify-space-between">
					<span>Total {{paginationProduct.total_data | toNumber}} Data</span>
					<v-pagination v-model="page" :length="paginationProduct.total_page" @input="changePage" total-visible="7" circle class="d-flex justify-end"></v-pagination>
				</v-col>
				<v-col cols="1" md="1" class="py-0 pl-0">
					<v-autocomplete :items="listLimit" v-model="limit" @input="changeLimit" hide-details class="mt-0" label="Item"></v-autocomplete>
				</v-col>
			</v-row>
		</div>
	</div>
</template>

<script>
import {mapActions, mapState, mapMutations} from 'vuex'
import filterComponent from '@/components/Filter'

const list_status = [{
	value: 1,
	text: 'Aktif'
}, {
	value: 0,
	text: 'Tidak Aktif'
}];

export default {
	inject: ['theme'],
	components: {
		filterComponent
	},
	data() {
		return {
			sortBy: 'product_id',
			sortDir: 'DESC',
			page: 1,
			limit: "10",
			listLimit: [ '5', '10', '20', '50', '100' ],
			dropfilter: false,
			search: '',
			headers: [
			{ text: 'Nama Produk', align: 'start', value: 'product_name'},
			{ text: 'Kode Produk', align: 'start', value: 'product_code'},
			{ text: 'Kategori Produk', value: 'product_category_name'},
			{ text: 'Unit Produk', value: 'product_unit', sortable: false },
			{ text: 'Berat Produk', value: 'product_weight'},
			{ text: 'Harga Produk', value: 'product_price'},
			{ text: 'Tipe Serial', value: 'product_is_serial_name'},
			{ text: 'Status', value: 'product_is_active', sortable: false },
			],
			params:[],
			isLoading: false,
			filterData: [{
				type: 'text',
				label: 'Nama Produk',
				filter: {
					value: '',
					comparison: 'like',
					type: 'string',
					field: 'product_name'
				}
			}, {
				type: 'text',
				label: 'Kode Produk',
				filter: {
					value: '',
					comparison: 'like',
					type: 'string',
					field: 'product_code'
				}
			}, {
				type: 'selection',
				label: 'Kategori Produk',
				itemValue: 'product_category_id',
				itemText: 'product_category_name',
				item: [],
				filter: {
					value: '',
					comparison: '=',
					type: 'string',
					field: 'product_category_id'
				}
			}, {
				type: 'selection',
				label: 'Tipe Serial',
				item: [{
					value: 0,
					text: 'Tanpa Serial'
				}, {
					value: 3,
					text: 'Serial Starter Kit'
				}, {
					value: 4,
					text: 'Serial Kartu 11 BV'
				}, {
					value: 5,
					text: 'Serial Kartu 12 BV'
				}],
				filter: {
					value: '',
					comparison: '=',
					type: 'string',
					field: 'product_is_serial'
				}
			}, {
				type: 'selection',
				label: 'Status Produk',
				item: list_status,
				filter: {
					value: '',
					comparison: '=',
					type: 'string',
					field: 'product_is_active'
				}
			}, 
			],
		}
	},
	computed: {
		...mapState(['filterParams']),
		...mapState('ecommerceProduct', ['listProduct', 'paginationProduct', 'detailCustomer']),
	},
	methods: {
		...mapActions('ecommerceProduct', ['getProduct', 'exportProduct', 'getProductCategory']),
		...mapMutations(['setFilter']),
		...mapMutations('ecommerceProduct', ['clearDataProduct']),

		getData() {
			this.getProduct(this.queryString({limit:this.limit, page: this.page, params:this.params, sort: this.sortBy, dir: this.sortDir}))
		},
		changePage(page) {
			this.page = page
			this.getData()
		},
		changeLimit(limit) {
			this.limit = limit
			this.page = 1
			this.getData()
		},
		exportData() {
			this.exportProduct(this.queryString({params:this.params, sort: this.sortBy, dir: this.sortDir}))
		},
		searchFilter(data) {
			this.params = data
			this.getData()
		},
		async onResetFilter() {
			this.params = []
			this.getData()
		},
	},
	beforeDestroy(){
		this.clearDataProduct()
	},
	watch: {
		option(val, old) {
			this.sortBy = val.sortBy[0]
			this.sortDir = val.sortDesc[0] ? 'ASC' : 'DESC'
			this.page = 1
			if (this.sortBy || (!this.sortBy && Object.keys(old).length > 0)) {
				this.getData()
			}
		}
	},
	async created() {
		await this.$store.dispatch('setPageTitle', `Product Ecommerce`)
		await this.getData()
		let indexCategory = await this.filterData.findIndex(el => el.label == 'Kategori Produk')
		this.filterData[indexCategory].item = await this.getProductCategory()

		await this.setFilter(this.filterData)
	},
};
</script>

<style>
